export default __webpack_public_path__ + "static/media/treat-yourself-2048w.d48e14f8.png";